'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _one = require('./one');

var _one2 = _interopRequireDefault(_one);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.routes.admin.schools', ['ui.router', 'ngMaterial', 'ifeis.routes.admin.schools.one']).config(function ($stateProvider) {
  $stateProvider.state('admin.schools', {
    url: '/schools',
    template: require('./tpl.html'),
    controller: 'AdminSchoolsController',
    ncyBreadcrumb: {
      label: 'Schools',
      parent: 'admin.dashboard'
    }
  });
}).controller('AdminSchoolsController', function ($scope, $location, fSchoolService, fNewSchoolDialog) {
  $scope.invitations = [];
  $scope.filterPlaceholer = "Filter";

  $scope.create = function ($event) {
    fNewSchoolDialog($event).then(function (s) {
      $scope.schools.push(s);
    });
  };

  // handles editing and deletion
  // if the selected schools is deleted, the object passed back from the dialog is undefined
  $scope.edit = function ($event, school) {
    fNewSchoolDialog($event, school, true).then(function (s) {
      $scope.schools[$scope.schools.indexOf(school)] = s;
    });
  };

  $scope.editTeachers = function (school) {
    $location.path('admin/schools/' + school.data.id);
  };

  function refresh() {
    $scope.loading = true;
    fSchoolService.all().then(function (schools) {
      $scope.loading = false;
      $scope.schools = schools;
    });
  }

  refresh();
});


//////////////////
// WEBPACK FOOTER
// ./routes/admin/schools/index.js
// module id = 516
// module chunks = 0